import React from 'react';
import { getCallbacks } from 'account-portal-library/lib/emailSignIn';
import TOUsernameFormView from '../Views/TO/Login/UsernameFormView'
import AppVars from '../../AppVars.js';
import axios from 'axios';

import { getGotoUrlFromCookies } from '../../gotoUrl';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';
import pushAnalytics from '../../analytics/pushAnalytics.js';
import { withNavigation } from '../../utils/withNavigation.js';

const appVars = AppVars.getInstance();

const COMPONENT_TREE = [
    { component_name: 'LoginPage', component_version: '1.0.0' },
    { component_name: 'UsernameForm', component_version: '1.0.0' }
];

const EMAIL_VERIFICATION_URL = "/emailcodeverification"
const PHONE_VERIFICATION_URL = "/phoneverification"
const OTP_LOGIN_URL = "/otplogin"
const DEALER_URL = "/dealer"
const INVALID_CREDS_URL = "/invalidcreds"
const ACCOUNT_LOCKED_URL = "/accountlocked"
const UNKNOWN_ERROR_URL = "/unknownerror"
const RESEND_ACTIVATION_EMAIL_URL = "/resend"

const NAVIGATION_URL = {
    "dealeraccount": DEALER_URL,
    "emailvalidation": EMAIL_VERIFICATION_URL,
    "otplogin": OTP_LOGIN_URL,
    "phonevalidation": PHONE_VERIFICATION_URL,
}
const INPUT_TYPES = {
    "PHONE": "^(?!0)[0-9]{10}$",
    "EMAIL": "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)"
}
const NEEDS_USERNAME = [RESEND_ACTIVATION_EMAIL_URL, EMAIL_VERIFICATION_URL, PHONE_VERIFICATION_URL, OTP_LOGIN_URL, DEALER_URL]

class UsernameForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            username: props.username || "",
            loading: false,
            isUsernameValid: null,
            isUsernameExists: null,
            isAccountLocked: null,
            onFocus: false,
            floatLabel: !props.username,
            hasStarted: false
        };
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.removeFocus = this.removeFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.sendJourneyPayload = this.sendJourneyPayload.bind(this);
        this.updateHasStarted = this.updateHasStarted.bind(this);
    }

    async sendJourneyPayload(journeyPayload, url, headers, params) {
        try {
            const resp = await axios({ method: 'post', url, headers, params, data: journeyPayload });
            return {
                response: resp.data,
                status: resp.status
            };
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            return {
                response: data,
                status: status,
                failureUrl: status === 401 ? data?.failureUrl || UNKNOWN_ERROR_URL : UNKNOWN_ERROR_URL
            };
        }
    };

    async startJourney() {
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
            const params = {
                'authIndexType': 'service',
                'authIndexValue': this.props.acr_values === "MFA" ? appVars.getMFATree() : appVars.getSignInTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=1.1',
                'Content-Type': 'application/json',
                ...(this.props.uid ? { 'x-username': this.props.uid } : {}),
            };
            // console.log("Journey Started");
            const journeyStart = await getCallbacks(url, headers, params);
            if (journeyStart.status !== 200) {
                throw journeyStart.response;
            }

            const initialResponse = journeyStart.response;
            // console.log("Initial Response -> ", initialResponse);

            if (initialResponse.callbacks.length === 2 && initialResponse.callbacks[0].type === "NameCallback") {
                initialResponse.callbacks[0].input[0].value = this.props.username;
                initialResponse.callbacks[1].input[0].value = "TO";
            }
            else {
                this.handleFailure(initialResponse);
            }

            const journeyResponse = await this.sendJourneyPayload(initialResponse, url, headers, params);
            // console.log("Journey Response(User Inputs Submit) -> ", journeyResponse);
            sessionStorage.AP_SSID = this.props.username;
            if (journeyResponse.status !== 200) {
                throw journeyResponse.response;
            }
            this.handleContinue(journeyResponse);
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async handleFormSubmit(event) {
        //Prevent default submit button behavior
        event.preventDefault();
        this.setState({ isAccountLocked: null, isUsernameExists: null, loading: true })
        //Check that form isn't blank
        const valid = this.validateInput()
        this.setState({ loading: false })

        if (valid) {
            this.props.saveSignInType(this.checkUsernameType(this.props.username))
            this.props.saveUsername(this.props.username)
            this.setState({ loading: true })
            this.startJourney();
        }
    }

    checkUsernameType(username) {
        let TYPE = null;
        for (const key in INPUT_TYPES) {
            if (username.match(INPUT_TYPES[key]) && appVars.getIncludeSignIn(key)) {
                TYPE = key;
            }
        }
        return TYPE;
    }

    validateInput() {
        return this.state.isUsernameValid;
    }

    handleFailure(journeyResponse) {
        const failureUrl = journeyResponse.failureUrl
        //If invalid credentials
        if (failureUrl === INVALID_CREDS_URL || failureUrl === "/usernotfound") {
            this.setState({ loading: false })
            this.setState({ isUsernameExists: false })
            if (this.checkUsernameType(this.props.username) === "EMAIL") {
                pushAnalytics('sys-action', { form_name: 'username-form', error_type: 'invalid-credentials', content_section: "Sign In Landing Page", metrics: 'km-form_field_submit-error', displayed_error_message: 'An account with this email address does not exist.' }, COMPONENT_TREE);
                this.props.saveStep("JOIN")
            } else {
                const username = this.props.username
                const displayPhone = "(" + username.substring(0, 3) + ") " + username.substring(3, 6) + "-" + username.substring(6, 10)
                pushAnalytics('sys-action', { form_name: 'username-form', error_type: 'invalid-credentials', content_section: "Sign In Landing Page", metrics: 'km-form_field_submit-error', displayed_error_message: `${displayPhone} isn't linked to an account. Please try a different sign in.` }, COMPONENT_TREE);
                this.props.saveUsernameExists(false)
                this.props.saveDisplayPhone(displayPhone)
            }
        } else if (failureUrl === ACCOUNT_LOCKED_URL) {
            pushAnalytics('km-form-error', { form_name: 'username-form', error_type: 'account-locked', content_section: "Sign In Landing Page", metrics: "km-form_field_submit_error", displayed_error_message: "This account is locked for 15 minutes due to multiple failed attempts." }, COMPONENT_TREE);
            this.setState({ loading: false })
            this.setState({ isAccountLocked: true })
            this.props.saveAccountLocked(true)
        }
        //If invalid credentials
        else if (NEEDS_USERNAME.includes(failureUrl)) {
            pushAnalytics('km-form-error', { form_name: 'username-form', error_type: 'needs-redirect', content_section: "Sign In Landing Page" }, COMPONENT_TREE);
            sessionStorage.AP_SSID = this.props.username
            if (failureUrl === EMAIL_VERIFICATION_URL) {
                this.props.saveURI()
            }
            if (this.props.style !== "TO") {
                navigateWithAnalytics(failureUrl + "#" + this.props.style, "error-redirect", "auto");
            } else {
                pushAnalytics('km-form-error', { form_name: 'username-form', error_type: 'unknown-error', content_section: "Sign In Landing Page" }, COMPONENT_TREE);
                navigateWithAnalytics(failureUrl, "error-redirect", "auto");
            }
        }
        else if (journeyResponse.errorMessage == 'Session has timed out') {
            pushAnalytics('km-form-error', { form_name: 'username-form', error_type: 'session-timeout', content_section: "Sign In Landing Page" }, COMPONENT_TREE);
            window.location.href = "/";
        }
        else {
            //this.setState({loading: false})
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        }
    }

    async handleContinue(journeyResponse) {
        try {
            const continuePayload = journeyResponse.response;
            if (continuePayload.callbacks[0].type === "NameCallback") {
                const flowName = continuePayload.callbacks[0].output[0].value;
                continuePayload.callbacks[0].input[0].value = flowName;
                const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
                // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
                const params = {
                    'authIndexType': 'service',
                    'authIndexValue': this.props.acr_values === "MFA" ? appVars.getMFATree() : appVars.getSignInTree()
                };
                const headers = {
                    'Accept-API-Version': 'resource=1.1',
                    'Content-Type': 'application/json',
                };
                const continueJourneyResponse = await this.sendJourneyPayload(continuePayload, url, headers, params);
                // console.log(`Journey Continues(${flowName} Flow Starts) -> `, continueJourneyResponse);
                if (continueJourneyResponse.status !== 200) {
                    throw continueJourneyResponse.response;
                }
                this.props.savePayload(continueJourneyResponse.response);
                sessionStorage.setItem("AP_PAYLOAD", JSON.stringify(continueJourneyResponse.response));
                sessionStorage.setItem("acr_values", this.props.acr_values);
                this.props.navigate(NAVIGATION_URL[flowName] || "/", { replace: true });
                return null;
            }
            else {
                this.props.savePayload(continuePayload);
                this.props.saveStep("PASSWORD");
            }
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    validateUsername(username) {
        if (username == null || username.length === 0 || this.checkUsernameType(username) === null) {
            return false;
        }
        return true;
    }

    updateUsernameValidity() {
        const isUserValid = this.validateUsername(this.props.username);
        if (!isUserValid) {
            pushAnalytics('sys-action', {
                error_type: "validation",
                displayed_error_message: "Please enter an email address or phone number",
                field_name: "username",
                form_name: "sign-in",
                content_section: "Sign In Landing Page",
                metrics: "km-form_field_entry-error",
                user_login_source: "Email",
            }, COMPONENT_TREE);
        }
        this.setState({ isUsernameValid: isUserValid });
    }

    validateForm(status) {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.username !== this.props.username) {
            this.updateUsernameValidity();
            this.setState({ floatLabel: !this.props.username })
        }
    }

    setFocus(event) {
        this.setState({ onFocus: true })
        this.setState({ floatLabel: false })
    }

    onBlur() {
        if (this.props.username === "") {
            this.setState({ floatLabel: true })
        } else {
            this.setState({ floatLabel: false })
        }
        this.updateUsernameValidity();
        this.removeFocus()
    }

    removeFocus() {
        this.setState({ onFocus: false })
    }

    updateHasStarted(value) {
        this.setState({ hasStarted: value })
    }

    render() {
        return (
            <TOUsernameFormView
                style={this.props.style}
                username={this.props.username}
                loading={this.state.loading}
                floatLabel={this.state.floatLabel}
                isUsernameValid={this.state.isUsernameValid}
                isUsernameExists={this.state.isUsernameExists}
                isAccountLocked={this.state.isAccountLocked}
                handleFormSubmit={this.handleFormSubmit}
                handleUsernameChange={(event) => {
                    this.setState({ username: event.target.value });
                    this.props.handleUsernameChange(event.target.value);
                }}
                onFocus={this.state.onFocus}
                setFocus={this.setFocus}
                removeFocus={this.removeFocus}
                onBlur={this.onBlur}
                showAlert={this.props.showAlert}
                hasStarted={this.state.hasStarted}
                updateHasStarted={this.updateHasStarted}
            />
        );
    }
}

export default withNavigation(UsernameForm);